import Layout from '../../components/flight-path/layout';
import Loader from '../../components/flight-path/loader';
import useI18n from '../../hooks/use-i18n';

const AuthRestrictLoader = () => {
  const i18n = useI18n();
  const pageMetaData = i18n.t('metadata').login_page;
  return (
    <Layout
      page="login"
      description={pageMetaData.description}
      title={pageMetaData.title}
      keywords={pageMetaData.keywords}
      analyticData={{ name: 'Login', properties: {} }}
      type="login"
      pageUrl="login"
      showFooter={false}
    >
      <Loader />
    </Layout>
  );
};

export default AuthRestrictLoader;
